<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useAdmin } from 'dashboard/composables/useAdmin';

const { isAdmin } = useAdmin();

const toggleSupportWidget = () => {
  if (window.$chatwoot) {
    window.$chatwoot.toggle();
  }
};
</script>

<template>
  <div class="flex w-full h-full bg-n-slate-2">
    <EmptyStateLayout
      :title="$t('APP_GLOBAL.BILLING_LOCKED.TITLE')"
      :subtitle="$t('APP_GLOBAL.BILLING_LOCKED.MESSAGE')"
      :show-backdrop="false"
    >
      <template #actions>
        <div class="flex flex-col items-center gap-3">
          <router-link v-if="isAdmin" :to="{ name: 'billing_settings_index' }">
            <NextButton
              :label="$t('APP_GLOBAL.BILLING_LOCKED.CHOOSE_PACKAGE')"
            />
          </router-link>
          <span v-else class="text-sm text-n-slate-11">
            {{ $t('APP_GLOBAL.BILLING_LOCKED.ASK_ADMIN') }}
          </span>
          <NextButton
            faded
            slate
            icon="i-lucide-life-buoy"
            :label="$t('SIDEBAR_ITEMS.CONTACT_SUPPORT')"
            @click="toggleSupportWidget"
          />
        </div>
      </template>
    </EmptyStateLayout>
  </div>
</template>
